<template>
    <p class="subheadline">Passwort</p>
    <div>
        <label for="password-value" class="small">Passwort*</label>
        <input id="password-value" class="input" type="password" required
               :class="{'is-danger':error}"
               :value="value"
               @input="$emit('update:value', $event.target.value)"
               @blur="validatePassword">
    </div>
    <div>
        <label for="password-compare" class="small">Passwort wiederholen*</label>
        <input id="password-compare" class="input" type="password" required
               :class="{'is-danger':error}"
               :value="compare"
               @input="$emit('update:compare', $event.target.value)"
               @blur="validatePassword">
        <span class="is-size-7 has-text-danger" v-if="error">{{ error }}</span>
    </div>
</template>

<script>

export default {
    name: 'RegisterFormPartPassword',
    props: {
        value: String,
        compare: String,
        error: String,
    },
    emits: [
        'update:value',
        'update:compare',
        'update:error'
    ],
    methods: {
        validatePassword() {
            let error = ''
            if (this.value.startsWith('#')) {
                error = 'Das Passwort darf nicht mit # beginnen'
            } else if (this.value.length < 8) {
                error = 'Das Passwort muss mind. 8 Zeichen lang sein'
            } else if (this.compare.length > 0 && this.value !== this.compare) {
                error = 'Die beiden Passwörter müssen identisch sein'
            }

            this.$emit('update:error', error)
        },
    }
}
</script>
